import {ButtonType} from 'types/components'

export const BUTTON_SIZE_MAP: Record<ButtonType, number> = {
  large: 56,
  normal: 40,
  small: 32,
  smallest: 28,
}
